/* eslint-disable */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ProfilesIcon extends BaseIcon {
  getChildren = () => [ <g fill={ this.getColor() }>
    <rect y="1" width="1" height="4"/>
    <rect y="1" width="4" height="1"/>
    <rect x="15" y="1" width="1" height="4"/>
    <rect x="12" y="1" width="4" height="1"/>
    <rect y="12" width="1" height="4"/>
    <rect y="15" width="4" height="1"/>
    <rect x="15" y="12" width="1" height="4"/>
    <rect x="12" y="15" width="4" height="1"/>
    <path fillRule='evenodd' d="M11.46,12.46,8.38,14H7.62L4.54,12.46,3,6.31,7.62,4h.71L13,6.31Z"/>
  </g> ]
  getViewBox = () => '0 0 16 16'
}
